cv.PublicPledgesRowView = Marionette.LayoutView.extend({
  tagName: "div",
  className: "donor",
  template: cv.Templates["public/pledges/pledges_row"],

  events: {},

  templateHelpers: function () {
    return {
      display_name:
        this.model.get("display_name") == "" ? "Anonymous Donor" : this.model.get("display_name"),
      amount: this.model.get("amount"),
      comment: this.model.get("comment"),
      currency_code: this.model.get("currency_code"),
    };
  },

  initialize: function (options) {
    console.log("PublicPledgesRowView initialized");
  },

  onShow: function () {},
});
